var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSystemShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "t5rgh536ba",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#t5rgh536ba)",
    transform: "translate(-231.000000, -363.000000) translate(0.000000, 339.000000) translate(198.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#DA322A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.257 4.555l1.265-1.251v9.922c0 .534.438.967.978.967s.978-.433.978-.967V3.304l1.265 1.251c.191.19.441.284.692.284.25 0 .5-.095.691-.284.383-.378.383-.99 0-1.368L8.192.283C8.169.261 8.145.24 8.12.22 8.11.21 8.098.203 8.087.195L8.043.163c-.014-.01-.028-.017-.041-.025C7.988.13 7.975.12 7.96.114l-.043-.02-.044-.02-.042-.016C7.816.053 7.8.046 7.784.042 7.77.037 7.755.034 7.74.03c-.017-.004-.033-.01-.05-.012C7.675.015 7.658.014 7.64.01L7.597.005C7.566.002 7.536 0 7.506 0h-.012c-.03 0-.06.002-.09.005-.016.001-.03.004-.045.006-.017.002-.034.004-.05.008-.017.003-.033.007-.049.012l-.044.01-.047.017-.043.016c-.015.006-.029.012-.042.019l-.045.021-.04.023-.042.026-.041.03-.036.026c-.024.02-.047.04-.069.061l-.003.003-2.935 2.904c-.382.378-.382.99 0 1.368.382.378 1.002.378 1.384 0z",
    transform: "translate(33.000000, 8.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.022 6.452h-2.609c-.54 0-.978.433-.978.967 0 .535.438.968.978.968h1.63v9.678H1.957V8.387h1.63c.54 0 .978-.433.978-.968 0-.534-.438-.967-.978-.967H.978c-.54 0-.978.433-.978.967v11.613c0 .535.438.968.978.968h13.044c.54 0 .978-.433.978-.968V7.42c0-.534-.438-.967-.978-.967z",
    transform: "translate(33.000000, 8.000000)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemShare);
export default __webpack_public_path__ + "static/media/system-share.b420fda4.svg";
export { ForwardRef as ReactComponent };